import React, { useState } from "react";
import "./ContactFormSection.css";

const ContactFormSection = () => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <section className="contact-form-section">
      <h2>Contact Us</h2>
      <form action="https://formspree.io/f/mdkkdgpb" method="POST">
        <div className="form-group">
          <label htmlFor="full-name">Full Name</label>
          <input
            type="text"
            id="full-name"
            name="full-name"
            placeholder="Enter your name"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="you@company.com"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="+1 (555) 000-0000"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message</label>
          <div className="message-container">
            <textarea
              id="message"
              name="message"
              placeholder="Leave us a message..."
              required
            ></textarea>
          </div>
        </div>
        <div className="form-group checkbox-wrapper">
          <input
            type="checkbox"
            id="privacy-policy"
            name="privacy-policy"
            checked={isChecked}
            onChange={handleCheckboxChange}
            required
          />
          <label htmlFor="privacy-policy">
            You agree to our{" "}
            <a href="/privacy-policy" target="_blank">
              friendly privacy policy
            </a>
          </label>
        </div>
        <button
          type="submit"
          className="contact-form-button"
          disabled={!isChecked}
        >
          Send Message
        </button>
      </form>
    </section>
  );
};

export default ContactFormSection;
